// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__8OXig","benefits__items":"Benefits_benefits__items__8aoxw","benefits__sighnup":"Benefits_benefits__sighnup__rWDH7"};